window.pp_gemius_use_cmp = true;
window.pp_gemius_cmp_timeout = Infinity;

window.triggerManualConsentChange = () => {
  window.manualConsentChange = true;
  window.Didomi.preferences.show();
};

window.didomiEventListeners = window.didomiEventListeners || [];
window.didomiEventListeners.push({
  event: 'consent.changed',
  listener: function () {
    if (window.manualConsentChange) {
      window.location.reload();
    }
  },
});

window.didomiOnReady = window.didomiOnReady || [];
